const ROUTE_PATHS = {
  HOME: '/',
  SIGNUP: '/signup',
  ONBOARDING: '/onboarding',
  TERMS_OF_SERVICE: 'https://www.airship.us/terms',
  onboardingStep: (step: string) => `/onboarding?step=${step}`,
};

export default ROUTE_PATHS;
